import { jsx as _jsx } from "react/jsx-runtime";
import Pagination from '@mui/material/Pagination';
var VariablePagination = function (props) {
    return (_jsx(Pagination, { count: props.count, page: props.page, onChange: props.onChange }));
};
export default VariablePagination;
